import { useContext } from 'react';
import { AuthContext } from 'src/components/Authentication/AuthContext';

export function useAuth() {
  return useContext(AuthContext);
}
